<template>
    <div class="pattern-input">
        <div v-if="viewMode == true" style="padding : 6px 2px; font-size : 13px;white-space: pre-wrap;">
            <span v-if="textBefore">{{ textBefore }}</span><span style="color:navy;" v-html="inputText"></span><span v-if="textAfter">{{ textAfter }}</span>
        </div>
        <div v-else>
            <div v-if="inputType == 'Text'">
                <span v-if="textBefore" class="inline-block">{{ textBefore }}</span>
                <div class="inline-block width-1-5x" :style="getInputStyle('Text')" :title="getLimitTitle()">
                    <el-input style="color:navy;padding:2px;" :disabled="readOnly" type="text" v-model="inputValue" clearable :maxlength="maxLength"></el-input>
                </div>
                <span v-if="textAfter" class="inline-block">{{ textAfter }}</span>
            </div>
            <div v-if="inputType == 'MlText'">
                <span v-if="textBefore" class="inline-block" style="vertical-align: top">{{ textBefore }}</span>
                <div class="inline-block width-1-5x" :style="getInputStyle('MlText')" :title="getLimitTitle()">
                    <el-input style="color:navy;padding:2px;" :disabled="readOnly" type="textarea" :autosize="txtAutoSize" v-model="inputValue" :maxlength="maxLength"></el-input>
                </div>
                <span v-if="textAfter" class="inline-block" style="vertical-align: top">{{ textAfter }}</span>
            </div>
            <div v-if="inputType == 'Num'" class="number">
                <span v-if="textBefore" class="inline-block">{{ textBefore }}</span>
                <div class="inline-block width-1-5x">
                    <el-input style="color:navy;padding:2px;" :style="getInputStyle('Num')" :disabled="readOnly" type="number" v-model.number="inputValue"></el-input>
                </div>
                <span v-if="textAfter" class="inline-block">{{ textAfter }}</span>
            </div>
            <div v-if="inputType == 'Date'">
                <span v-if="textBefore" class="inline-block">{{ textBefore }}</span>
                <el-date-picker style="color:navy;padding:2px;width:144px;" :style="getInputStyle('Date')" :disabled="readOnly" v-model="inputValue" type="date" placeholder="选择日期"></el-date-picker>
                <span v-if="textAfter" class="inline-block">{{ textAfter }}</span>
            </div>
            <div v-if="inputType == 'Bool'">
                <span v-if="textBefore" class="inline-block">{{ textBefore }}</span>
                <div class="inline-block" style="padding:7px;">
                    <el-radio-group :disabled="readOnly" v-model="inputValue">
                        <el-radio :label="true">{{ textBoolTrue }}</el-radio>
                        <el-radio :label="false">{{ textBoolFalse }}</el-radio>
                    </el-radio-group>
                </div>
                <span v-if="textAfter" class="inline-block">{{ textAfter }}</span>
            </div>
            <div v-if="inputType == 'Single'">
                <span v-if="textBefore" class="inline-block">{{ textBefore }}</span>
                <div v-if="asDropdown==true" class="inline-block" style="padding:2px;">
                    <el-select :disabled="readOnly" v-model="inputValue" style="color:navy;width:140px;" :style="getInputStyle('Single')">
                        <el-option v-for="option in selectOptions" :key="option['value']" :disabled="option['disabled']==true" :label="option['text']" :value="option['value']"></el-option>
                    </el-select>
                </div>
                <div v-else="" class="inline-block" style="padding:7px;">
                    <el-radio-group :disabled="readOnly" v-model="inputValue">
                        <el-radio v-for="option in selectOptions" :label="option.value">{{ option.text }}</el-radio>
                    </el-radio-group>
                </div>
                <span v-if="textAfter" class="inline-block">{{ textAfter }}</span>
            </div>
            <div v-if="inputType == 'Multi'">
                <span v-if="textBefore" class="inline-block">{{ textBefore }}</span>
                <div v-if="asDropdown==true" class="inline-block" style="padding:2px;">
                    <el-select :disabled="readOnly" :multiple="'true'" v-model="inputValue" style="color:navy;width:280px;" :style="getInputStyle('Multi')">
                        <el-option v-for="option in selectOptions" :key="option['value']" :disabled="option['disabled']==true" :label="option['text']" :value="option['value']"></el-option>
                    </el-select>
                </div>
                <div v-else="" class="inline-block" style="padding:7px;">
                    <el-checkbox-group :disabled="readOnly" v-model="inputValue">
                        <el-checkbox v-for="option in selectOptions" :label="option.value">{{ option.text }}</el-checkbox>
                    </el-checkbox-group>
                </div>
                <span v-if="textAfter" class="inline-block">{{ textAfter }}</span>
            </div>
        </div>
    </div>

</template>

<script>
    // last modified by koqiui
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, getInputTypes} from '../../app.vues'

    // 调用  parsePattern('是否开启手机短信登录：${启用} 呗', '${', '}')
    // 结果 => { textBefore : '是否开启手机短信登录：', textAfter : ' 呗', textExtra : '启用'}
    function parsePattern(pattern = '', placeholderPrefix = '{', placeholderSuffix = '}') {
        let retInfo = {};
        //
        let index1 = pattern.indexOf(placeholderPrefix);
        if (index1 == -1) {
            //连占位符前缀都没有
            retInfo.textBefore = pattern;
        } else {
            retInfo.textBefore = pattern.substring(0, index1);

            let index11 = index1 + placeholderPrefix.length;

            let index22 = pattern.indexOf(placeholderSuffix, index11);

            if (index22 == -1) {
                //有占位符前缀 但 没占位符后缀
                retInfo.textBefore = pattern;
            } else {
                if (index22 > index11) {
                    retInfo.textExtra = pattern.substring(index11, index22)
                }

                let index2 = index22 + placeholderSuffix.length;

                retInfo.textAfter = pattern.substring(index2);
            }

        }
        return retInfo;
    }

    //console.log(parsePattern('是否开启手机短信登录：{启用} 呗'));
    //console.log(parsePattern('是否开启手机短信登录：{预付费:1|按支付单据:2} 呗'));

    //启用/不启用
    function parseBoolItemsText(boolText = '是/否') {
        let pair = boolText.split('/');
        if (pair.length < 2) {
            pair[1] = '不' + pair[0];
        }
        return pair;
    }

    //预付费:1|按支付单据:2:disabled|年费:3
    function parseOptionItemsText(optionItemsText, valueType) {
        optionItemsText = optionItemsText.replace(/：+/, ':');
        let retOptions = [];
        let itemsPair = optionItemsText.split('|');
        //
        for (let i = 0; i < itemsPair.length; i++) {
            let itemText = itemsPair[i];
            let itemPair = itemText.split(':');
            let text = itemPair[0];
            let value = itemPair[1];
            if (valueType == 'Integer') {
                value = Utils.ParseInt(value);
            }
            retOptions[i] = {
                text: text,
                value: value
            };
            //
            let disabled = false;
            if (itemPair.length > 2) {
                disabled = itemPair[2].trim() == 'disabled';
            }
            if (disabled) {
                retOptions[i].disabled = true;
            }
            //console.log(retOptions[i]);
        }
        //
        return retOptions;
    }

    //console.log(parseOptionItemsText('预付费:1|按支付单据:2'));

    let InputTypesList = getInputTypes();
    let InputTypeNames = InputTypesList.pluck('name');

    //console.log(InputTypeNames);
    function isValidInputType(inputType) {
        return inputType != null && InputTypeNames.indexOf(inputType) != -1;
    }

    //
    function isValidValueTypeForInputType(valueType, inputType) {
        let targetTypeInfo = InputTypesList.find(function (typeInfo) {
            return typeInfo.name == inputType;
        });
        //
        return targetTypeInfo != null && targetTypeInfo.valueTypes.indexOf(valueType) != -1;
    }

    function formalizeValue(inputType = 'Text', valueType = 'String', initValue = null, viewMode = false, metaText) {
        if (inputType == 'Num') {
            valueType = valueType || 'Integer';
            //
            if (valueType == 'Integer' || valueType == 'Long') {
                return Utils.ParseInt(initValue);
            } else {
                return Utils.ParseFloat(initValue);
            }
        } else if (inputType == 'Date') {
            valueType = valueType || 'Date';
            //
            let date = Date.parseAsDate(initValue);
            if (viewMode) {
                return Utils.isDate(date) ? date.format('yyyy-MM-dd') : date;
            } else {
                return date;
            }
        } else if (inputType == 'Bool') {
            valueType = valueType || 'Boolean';
            //
            let bool = false;
            if (typeof initValue == 'string') {
                bool = initValue.toLowerCase().isIn('true', 't', 'yes', 'y', '1');
            } else {
                bool = new Boolean(initValue).valueOf();
            }
            let boolTextPair = parseBoolItemsText(metaText);
            return viewMode ? (bool ? boolTextPair[0] : boolTextPair[1]) : bool;
        } else if (inputType == 'Single') {
            valueType = valueType || 'Integer';
            //
            let optionVal = initValue;
            if (valueType == 'Integer') {
                optionVal = Utils.ParseInt(initValue);
            }
            //
            if (viewMode) {
                let options = parseOptionItemsText(metaText, valueType);
                let option = options.find(function (opt) {
                    return opt.value == optionVal;
                });
                return option == null ? '<未设置>' : option.text;
            } else {
                return optionVal;
            }
        } else if (inputType == 'Multi') {
            valueType = valueType || 'Integer';
            //
            let optionVals = initValue || [];
            if (!Utils.isArray(optionVals)) {
                optionVals = optionVals + '';
                optionVals = optionVals.trim();
                //[1, 2, 3] 形式的去掉 前后的[]
                if (optionVals.startsWith('[') && optionVals.endsWith(']')) {
                    optionVals = optionVals.substring(1, optionVals.length - 1);
                }
                let tmpVals = optionVals.split(',');
                optionVals = [];
                for (var i = 0, c = tmpVals.length; i < c; i++) {
                    let tmpVal = (tmpVals[i] + '').trim();
                    if (tmpVal.length !== '') {
                        if (valueType == 'Integer') {
                            tmpVal = Utils.ParseInt(tmpVal);
                        }
                        if (tmpVal != null) {
                            optionVals.push(tmpVal);
                        }
                    }
                }
            }
            //
            if (viewMode) {
                let options = parseOptionItemsText(metaText, valueType);
                let selected = [];
                for (let i = 0, c = options.length; i < c; i++) {
                    let option = options[i];
                    if (optionVals.contains(option.value)) {
                        selected.push(option.text);
                    }
                }
                return selected.length == 0 ? '<未设置>' : selected.join('、');
            } else {
                return optionVals;
            }
        } else if (inputType == 'MlText') {
            valueType = valueType || 'String';
            //
            if (viewMode) {
                if (initValue != null) {
                    initValue = '<pre style="display:inline-block;vertical-align:top;min-height: 33px;">' + initValue + '</pre>';
                }
            }
        }

        return initValue;
    }

    export default {
        name: 'swb-pattern-input',
        desc: '模式化输入',
        props: {
            viewMode: {
                //是否查看模式
                type: Boolean,
                default: false
            },
            placeholderPrefix: {
                //占位符前缀
                type: String,
                default: '{'
            },
            placeholderSuffix: {
                //占位符后缀
                type: String,
                default: '}'
            },
            // Bool: {是/否}
            // Single : {预付费:1|按支付单据:2|disabled|年费:3}
            pattern: {
                //模式字符串
                type: String,
                default: ''
            },
            initValue: {
                //初始值
                default: null
            },
            inputType: {
                //输入类型 Text, MlText, Num, Date, Bool, Single, Multi
                type: String,
                default: 'Text'
            },
            asDropdown: {
                //（单选时）是否当作下拉列表
                type: Boolean,
                default: false
            },
            inputWidth: {
                //输入宽度（像素数）
            },
            valueType: {
                //终值类型（java类型：String, Integer, Float, Date, Boolean
                type: String,
                default: 'String'
            },
            readOnly: {
                //是否只读模式（有别于查看模式，这里会渲染输入控件）
                type: Boolean,
                default: false
            },
            minRows: {
                //多行文本有效
                type: Number,
                default: 2
            },
            maxRows: {
                //多行文本有效
                type: Number,
                default: 10
            },
            maxLength: {//-1：代表不限制
                type: Number,
                default: -1
            }
        },
        data: function () {
            return {
                inputValue: null,
                inputText: null,
                textBefore: null,
                textAfter: null,
                textBoolTrue: '是',
                textBoolFalse: '否',
                selectOptions: [],
                //
                txtAutoSize: {
                    minRows: 2,
                    maxRows: 10
                }
            }
        },
        watch: {
            viewMode(newVal, oldVal) {
                this.render();
            },
            minRows(newVal, oldVal) {
                this.refreshSizeLimit();
            },
            maxRows(newVal, oldVal) {
                this.refreshSizeLimit();
            },
            initValue(newVal, oldVal) {
                this.inputValue = newVal;
                //
                this.render();
            }
        },
        //
        mounted() {
            this.render();
        },
        methods: {
            getInputStyle(inputType) {
                let style = {};
                //
                let width = Utils.ParseInt(this.inputWidth);
                if (width > 0) {
                    if (inputType == 'Text' || inputType == 'MlText' || inputType == 'Num' || inputType == 'Date') {
                        style['width'] = width + 'px';
                    } else if ((inputType == 'Single' || inputType == 'Multi') && this.asDropdown) {
                        style['width'] = width + 'px';
                    }
                }
                //
                return style;
            },
            getLimitTitle() {
                if (this.viewMode || this.readOnly || this.maxLength < 0) {
                    return '';
                }
                //
                return '字符数限制：' + this.maxLength + '个';
            },
            refreshSizeLimit() {
                this.txtAutoSize = Utils.merge(this.txtAutoSize, {
                    minRows: this.minRows,
                    maxRows: this.maxRows
                });
            },
            render() {
                this.refreshSizeLimit();
                //
                let patternInfo = parsePattern(this.pattern, this.placeholderPrefix, this.placeholderSuffix);

                //console.log(patternInfo);
                this.textBefore = patternInfo.textBefore;
                this.textAfter = patternInfo.textAfter;
                //
                if (!isValidInputType(this.inputType)) {
                    console.error('输入类型错误，支持的输入类型有：' + InputTypeNames.join(", "));
                    //
                    return;
                }
                if (!isValidValueTypeForInputType(this.valueType, this.inputType)) {
                    console.error('值类型【' + this.valueType + '】错误，与输入类型【' + this.inputType + '】不匹配：');
                    //
                    return;
                }

                let metaText = patternInfo.textExtra;
                if (this.inputType == 'Bool') {
                    let boolTextPair = parseBoolItemsText(metaText);
                    this.textBoolTrue = boolTextPair[0];
                    this.textBoolFalse = boolTextPair[1];
                } else if (this.inputType == 'Single' || this.inputType == 'Multi') {
                    this.selectOptions = parseOptionItemsText(metaText, this.valueType);
                }
                //
                let targetValue = this.inputValue === null ? this.initValue : this.inputValue;
                if (this.viewMode) {
                    this.inputText = formalizeValue(this.inputType, this.valueType, targetValue, this.viewMode, metaText);
                } else {
                    this.inputValue = formalizeValue(this.inputType, this.valueType, targetValue, this.viewMode, metaText);
                }
                // console.log(this.inputValue);
            },
            //
            getValue() {
                let retValue = typeof this.inputValue === 'undefined' ? null : this.inputValue;
                if (this.inputType == 'Num') {
                    if (this.valueType == 'Integer' || this.valueType == 'Long') {
                        retValue = Utils.ParseInt(retValue);
                    } else {
                        retValue = Utils.ParseFloat(retValue);
                    }
                } else if (this.inputType == 'Date') {
                    if (this.valueType == 'String') {
                        retValue = Utils.isDate(retValue) ? retValue.format('yyyy-MM-dd') : retValue;
                    }
                }
                //
                return retValue;
            }
        }
    }

</script>

<style>
    .pattern-input .el-radio {
        margin-right: 20px;
    }

    .pattern-input .el-radio__label {
        font-size: 13px;
        color: navy;
    }

    .pattern-input input, .pattern-input textarea {
        color: navy;
        font-size: 13px;
    }

    .pattern-input .number .el-input {
        width: 144px;
    }

    .pattern-input .number input {
        text-align: right;
    }
</style>




// WEBPACK FOOTER //
// src/compo/ctrl/PatternInput.vue